import React, { useState, useEffect } from 'react';
import { Alert, LinearProgress } from '@mui/material';
import sprintSyncStatusService from '../../services/sprintSyncStatusService';

/**
 * Global top-of-page banner shown while a sprint data sync (ADO + GitHub
 * refresh) is in progress. Rendered once above all routes so it stays
 * visible across navigation for the duration of the sync.
 */
const SprintSyncBanner = () => {
  const [state, setState] = useState(sprintSyncStatusService.getState());

  useEffect(() => {
    const handleChange = (next) => setState(next);
    sprintSyncStatusService.addListener(handleChange);
    setState(sprintSyncStatusService.getState());
    return () => sprintSyncStatusService.removeListener(handleChange);
  }, []);

  if (!state.isSyncing) return null;

  return (
    <Alert
      severity="info"
      icon={false}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.modal + 1,
        borderRadius: 0,
        justifyContent: 'center',
        '& .MuiAlert-message': { width: '100%', textAlign: 'center' },
      }}
    >
      {state.message || 'Sprint data is being refreshed…'}
      <LinearProgress sx={{ mt: 0.5 }} />
    </Alert>
  );
};

export default SprintSyncBanner;
